//https://www.golinuxcloud.com/mathtoradians-javascript/

export function degreesToRadians(degrees) {
    return (degrees % 360) * (Math.PI / 180);
}